import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import App from '../App';
import Login from '../Login';
import ForgotPassword from '../ForgotPassword';

import { observer, inject } from 'mobx-react';

@inject('authStore')
@observer
class RouterAuth extends Component {
  componentDidMount = () => {
    this.checkSessionInterval = setInterval(() => {
      this.props.authStore.checkSession();
    }, 1000 * 60 * 10);
  };

  componentWillUnmount = () => {
    clearInterval(this.checkSessionInterval);
  };

  render() {
    const { isLoggedIn } = this.props.authStore;
    return (
      <Router>
        <Switch>
          <Route path="/logout" component={Login} />
          <Route path="/login" component={Login} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/" render={() => (isLoggedIn ? <App /> : <Redirect to="/login" />)} />
        </Switch>
      </Router>
    );
  }
}

export default RouterAuth;
